<template>
  <div class="delete-confirm-overlay" v-if="open" @click.self="$emit('cancel')">
    <div class="delete-confirm-modal">
      <div class="modal-icon">
        <close-circle-outlined />
      </div>

      <div class="modal-content">
        <h3 class="modal-title">删除确认</h3>
        <p class="modal-message">
          确定要删除
          <span class="media-name">{{ mediaName }}</span>
          吗？
        </p>
        <p class="modal-warning">此操作不可恢复，请谨慎操作！</p>
      </div>

      <div class="modal-actions">
        <button class="btn btn-cancel" @click="$emit('cancel')">取消</button>
        <button class="btn btn-delete" @click="$emit('confirm')">确认删除</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
defineProps({
  open: Boolean,
  mediaName: String
})

defineEmits(['confirm', 'cancel'])
</script>

<style lang="scss" scoped>
.delete-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: fadeIn 0.2s ease-out;
  backdrop-filter: blur(4px);
}

.delete-confirm-modal {
  width: 400px;
  max-width: 90vw;
  padding: 32px;
  background: #001529;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  text-align: center;
  animation: scaleIn 0.3s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.1);

  .modal-icon {
    width: 72px;
    height: 72px;
    margin: 0 auto 24px;
    background: rgba(245, 34, 45, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(245, 34, 45, 0.3);

    span {
      font-size: 36px;
      color: #f5222d;
    }
  }

  .modal-content {
    margin-bottom: 32px;

    .modal-title {
      margin: 0 0 16px 0;
      font-size: 20px;
      font-weight: 600;
      color: #fff;
    }

    .modal-message {
      margin: 0 0 12px 0;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.5;

      .media-name {
        color: #1890ff;
        font-weight: 500;
        word-break: break-all;
      }
    }

    .modal-warning {
      margin: 0;
      font-size: 14px;
      color: #faad14;
      font-weight: 500;
    }
  }

  .modal-actions {
    display: flex;
    gap: 16px;
    justify-content: center;

    .btn {
      min-width: 120px;
      height: 44px;
      padding: 0 24px;
      border-radius: 8px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &-cancel {
        background: rgba(255, 255, 255, 0.05);
        color: rgba(255, 255, 255, 0.7);
        border: 1px solid rgba(255, 255, 255, 0.15);

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
          border-color: rgba(255, 255, 255, 0.25);
        }
      }

      &-delete {
        background: linear-gradient(135deg, #f5222d, #fa541c);
        color: #fff;
        box-shadow: 0 4px 12px rgba(245, 34, 45, 0.3);

        &:hover {
          background: linear-gradient(135deg, #ff4d4f, #fa8c16);
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(245, 34, 45, 0.4);
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 响应式设计
@media (max-width: 480px) {
  .delete-confirm-modal {
    padding: 24px;

    .modal-icon {
      width: 64px;
      height: 64px;
      margin-bottom: 20px;

      i {
        font-size: 32px;
      }
    }

    .modal-content {
      .modal-title {
        font-size: 18px;
        margin-bottom: 12px;
      }

      .modal-message {
        font-size: 15px;
      }
    }

    .modal-actions {
      flex-direction: column;
      gap: 12px;

      .btn {
        width: 100%;
      }
    }
  }
}
</style>
